import PageGeneral from 'components/pages/general';
import { getStaticProps as getStaticPropsPageGeneral } from './[slug]';

export default PageGeneral;

export const getStaticProps = page =>
  getStaticPropsPageGeneral({ ...page, params: { ...page.params, slug: '/' } });
